import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { ShippingService } from 'idt-ecommerce-api/shipping/shipping.service';
import { ShippingMethod } from 'idt-ecommerce-api/shipping/models/shipping.model';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'piece-shipping-methods-render',
  templateUrl: './piece-shipping-methods-render.component.html',
  styleUrls: ['./piece-shipping-methods-render.component.scss']
})
export class PieceShippingMethodsRenderComponent
  extends BaseRenderComponent<any>
  implements OnInit {

  public shippings: ShippingMethod[] = [];

  constructor(
    private cd: ChangeDetectorRef,
    private shippingService: ShippingService,
  ) {
    super();
  }

  public ngOnInit() {
    this.shippingService.getShippingMethods(true)
      .pipe(takeUntil(this.clearSubscriptions$))
      .subscribe((shippings: ShippingMethod[]) => {
        this.shippings = shippings;
        this.cd.markForCheck();
      });
  }

  public getPromotion(shipping: ShippingMethod) {
    if (!isDefined(shipping.promotions) || shipping.promotions.length === 0) {
      return '';
    }
    const firstPromotion = shipping.promotions[0];
    return `${firstPromotion.shortDesc} ${firstPromotion.priceMinWithSymbol}`;
  }
  public trackByIndex(index: number): number {
    return index;
  }

}
